import { useState } from 'react';

export default function NewTicketForm({ api, onCreated }) {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  async function submit(e) {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) return;
    setSending(true);
    setError(null);
    try {
      const { data } = await api.post('/tickets', { subject, body });
      onCreated(data.ticket);
    } catch {
      setError('Could not send your message. Try again in a moment.');
    } finally {
      setSending(false);
    }
  }

  return (
    <form onSubmit={submit} className="p-4 space-y-3">
      <div>
        <label className="text-xs font-medium text-gray-600">Subject</label>
        <input
          className="input-field mt-1"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="What do you need help with?"
        />
      </div>
      <div>
        <label className="text-xs font-medium text-gray-600">Message</label>
        <textarea
          className="input-field mt-1 min-h-[120px]"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Give us the details."
        />
      </div>
      {error && <p className="text-xs text-red-600">{error}</p>}
      <button type="submit" className="btn-primary w-full" disabled={sending}>
        {sending ? 'Sending...' : 'Send'}
      </button>
    </form>
  );
}
